/* eslint-disable */
import Swiper from 'swiper/js/swiper';
import Lightbox from 'lightbox2/src/js/lightbox';

export default {
  init() {
    // JavaScript to be fired on all pages
    let buttons = document.querySelectorAll('.btn');

    if (buttons != null) {
      for(let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('mousemove', function(e) {
          let rect = e.target.getBoundingClientRect();
          let x = e.clientX - rect.left;
          let y = e.clientY - rect.top;

          e.target.style.setProperty('--x', `${ x }px`)
          e.target.style.setProperty('--y', `${ y }px`)
        });
      }
    }

    const grid = document.querySelector('.projects-list .grid');

    if (grid != null) {
      setTimeout(function() {
        const msnry = new Masonry( grid, {
          itemSelector: '.grid-item',
          columnWidth: 359,
          gutter: 28
        });

        imagesLoaded( grid ).on( 'progress', function() {
          msnry.layout();
        });
      }, 200);
    }


    setTimeout(function() {
      const mapbox = document.getElementById('mapbox');

      if (mapbox != null) {
        const coordinates = {
          lng: parseFloat(mapbox.getAttribute('data-lng')),
          lat: parseFloat(mapbox.getAttribute('data-lat')),
        };

        let mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

        mapboxgl.accessToken = 'pk.eyJ1IjoiYm9yaXNjaGFiaXJhbmQiLCJhIjoiY2s0c2dyd202MG02MzNtbzFubGhoeWNncSJ9.y7gmAAarEflMQfiUegiceQ';
        let map = new mapboxgl.Map({
          container: 'mapbox',
          style: 'mapbox://styles/mapbox/streets-v11',
          center: [coordinates.lng, coordinates.lat],
          zoom: 12
        });

        map.scrollZoom.disable();
        map.addControl(new mapboxgl.NavigationControl());

        let el = document.createElement('div');
        el.className = 'marker';

        new mapboxgl.Marker(el).setLngLat([coordinates.lng, coordinates.lat]).addTo(map);
      }

    }, 200);

    let breadcrumbs = document.querySelector('.breadcrumbs .back');

    if(breadcrumbs != null) {
      breadcrumbs.addEventListener('click', function(e) {
        window.history.back();
        e.preventDefault();
      });
    }


    let fileBrowser = document.querySelectorAll('.custom-file-input');


    if(fileBrowser != null) {
      for(let i = 0; i < fileBrowser.length; i++) {
        fileBrowser[i].addEventListener('change', function() {
          this.parentNode.parentNode.querySelector('.custom-file-label').innerText = this.value;
        });
      }
    }

    let forms = document.querySelectorAll('.wpcf7 form');

    if(forms != null) {
      for(let i = 0; i < forms.length; i++) {
        let submit = forms[i].querySelector('input[type="submit"]');
        if (submit != null) {
          submit.classList.add('disabled');
          submit.setAttribute('disabled', true);
        }

        let acceptance = forms[i].querySelector('.custom-checkbox input[name="acceptance"]');
        if (acceptance != null) {
          acceptance.addEventListener('change', function() {
            if(acceptance.checked) {
              submit.classList.toggle('disabled');
              submit.removeAttribute('disabled');
            } else {
              submit.classList.add('disabled');
              submit.setAttribute('disabled', true);
            }
          });
        }
      }
    }

    let printButton = document.querySelector('[data-toggle="print"]');
    if (printButton != null) {
      printButton.addEventListener('click', function(e) {
        e.preventDefault();
        window.print();
      })
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js